const xsrfToken: string =
  document.getElementById("csrf-token")?.getAttribute("content") ||
  "8e13d2c8-28c7-4a83-8bd6-186fb45543ad";

interface ApiConstants {
  USER_URL: string;
  PERMISSIONS_URL: string;
  XSRF: string;
  SESSION: string;
}

const apiConstants: ApiConstants = {
  USER_URL: `/api/v1/user`,
  PERMISSIONS_URL: `/api/v1/user/permissions`,
  XSRF: xsrfToken,
  SESSION: "e2f452d1-3f4b-4416-a138-c217cb92c745",
};

export default apiConstants;
